module.exports = __webpack_public_path__ + "img/c9f41da.png";